import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/contelizer-easyitem-com/prestashop-rest-front/app/layouts/default.vue").then(m => m.default || m))
}